
import slot_json from "../_asset/media/list_slot.json"

import img_pragmatic from "../_asset/slot/gif/pragmatic.gif"
import img_pragmatic_J from "../_asset/slot/gif/pragmatic J.gif"
import img_cq9 from "../_asset/slot/list/cq9.jpg"
import img_netent from "../_asset/slot/gif/netent.gif"
import img_redtiger from "../_asset/slot/list/redtiger.jpg"
import img_playngo from "../_asset/slot/list/playngo.jpg"
import img_booongo from "../_asset/slot/gif/booongo.gif"
import img_playson from "../_asset/slot/gif/playson.gif"
import img_nolimit from "../_asset/slot/list/nolimit.jpg"
import img_1x2gaming from "../_asset/slot/list/1x2gaming.jpg"
import img_blueprintgaming from "../_asset/slot/gif/blueprint.gif"
import img_dragoonsoft from "../_asset/slot/list/dragoonsoft.jpg"
import img_dreamtech from "../_asset/slot/list/dreamtech.jpg"
import img_elkstudios from "../_asset/slot/list/elkstudios.jpg"
import img_evoplay from "../_asset/slot/gif/evoplay.gif"
import img_gameart from "../_asset/slot/list/gameart.jpg"
import img_habanero from "../_asset/slot/list/habanero.jpg"
import img_microgaming from "../_asset/slot/gif/microgamingslot.gif"
import img_mobilots from "../_asset/slot/list/mobilots.jpg"
import img_playpears from "../_asset/slot/list/playpears.jpg"
import img_playstar from "../_asset/slot/list/playstar.jpg"
import img_pgsoft from "../_asset/slot/gif/pgsoft.gif"
import img_relaxgaming from "../_asset/slot/list/relaxgaming.jpg"
import img_thunderkick from "../_asset/slot/list/thunderkick.jpg"
import img_wazdan from "../_asset/slot/gif/wazdan.gif"
import img_BigTimeGaming from "../_asset/slot/gif/BigTimeGaming.gif"
import img_greentube from "../_asset/slot/gif/greentube.gif"
import img_amatic from "../_asset/slot/gif/amatic.gif"
import img_popok from "../_asset/slot/gif/popok.gif"
import img_kagaming from "../_asset/slot/gif/kagaming.gif"
import img_PlayTechSlot from "../_asset/slot/list/playtechslotimg.png"

import logo_PragmaticPlayX from "../_asset/slot/logo/pragmatic X.png"
import logo_PragmaticPlayJ from "../_asset/slot/logo/pragmatic J.png"
import logo_CQ9 from "../_asset/slot/logo/CQ9.png"
import logo_netent from "../_asset/slot/logo/netent.png"
import logo_redtiger from "../_asset/slot/logo/Red Tiger Gaming.png"
import logo_playngo from "../_asset/slot/logo/Play’n GO.png"
import logo_Booongo from "../_asset/slot/logo/BNG.png"
import logo_Playson from "../_asset/slot/logo/Playson.png"
import logo_NolimitCity from "../_asset/slot/logo/nolimit-city.png"
import logo_PGSoft from "../_asset/slot/logo/PGSoft.png"
import logo_Habanero from "../_asset/slot/logo/habanero.png"
import logo_BlueprintGaming from "../_asset/slot/logo/blueprintgaming.png"
import logo_DragoonSoft from "../_asset/slot/logo/dragoonsoft.png"
import logo_PlayStar from "../_asset/slot/logo/playstar.png"
import logo_GameArt from "../_asset/slot/logo/gameart.png"
import logo_RelaxGaming from "../_asset/slot/logo/relaxgaming.png"
import logo_microgaming from "../_asset/slot/logo/microgaming.png"
import logo_BigTimeGaming from "../_asset/slot/logo/BigTimeGaming.png"
import logo_PlayPearls from "../_asset/slot/logo/playpears.png"
import logo_Wazdan from "../_asset/slot/logo/wazdan.png"
import logo_EVOPLAY from "../_asset/slot/logo/evoplay.png"
import logo_1X2Gaming from "../_asset/slot/logo/1X2Gaming.png"
import logo_dreamtech from "../_asset/slot/logo/dreamtech.png"
import logo_ElkStudios from "../_asset/slot/logo/ElkStudios.png"
import logo_Thunderkick from "../_asset/slot/logo/thunderkick.png"
import logo_Mobilots from "../_asset/slot/logo/mobilots.png"
import logo_greentube from "../_asset/slot/logo/greentube.png"
import logo_amatic from "../_asset/slot/logo/amatic.png"
import logo_popok from "../_asset/slot/logo/popok.png"
import logo_kagaming from "../_asset/slot/logo/kagaming.png"
import logo_PlayTechSlot from "../_asset/slot/logo/playtechlogo.png"

type GameCompanyListType = 'PragmaticPlay' | 'PragmaticPlay J'
    | 'CQ9' | 'PG Soft' | 'Booongo' | 'Habanero'
    | 'netent' | 'Playson' | 'Mobilots' | 'Nolimit City' | 'Blueprint Gaming' | 'PlayPearls'
    | 'dragoonsoft' | 'Thunderkick' | 'PlayStar' | 'redtiger' | 'GameArt' | 'Relax Gaming'
    | 'Wazdan' | 'EVOPLAY' | 'playngo' | '1X2 Gaming' | 'dreamtech' | 'Elk Studios'
    | 'MicroGaming Plus Slo' | 'BigTimeGaming' | 'greentube' | 'amatic' | 'popok' | 'kagaming' | 'PlayTechSlot'
export interface SlotImageInterface {
    id: string,
    name: string,
    vendor: GameCompanyListType,
    img: string,
    logo: string,
}
export const compL_slot = {
    "PragmaticPlay": {
        img: img_pragmatic,
        logo: logo_PragmaticPlayX,
    },
    "PragmaticPlay J": {
        img: img_pragmatic_J,
        logo: logo_PragmaticPlayJ
    },
    "CQ9": {
        img: img_cq9,
        logo: logo_CQ9
    },
    "PG Soft": {
        img: img_pgsoft,
        logo: logo_PGSoft
    },
    "Booongo": {
        img: img_booongo,
        logo: logo_Booongo
    },
    "Habanero": {
        img: img_habanero,
        logo: logo_Habanero
    },
    "netent": {
        img: img_netent,
        logo: logo_netent
    },
    "Playson": {
        img: img_playson,
        logo: logo_Playson
    },
    "Mobilots": {
        img: img_mobilots,
        logo: logo_Mobilots
    },
    "Nolimit City": {
        img: img_nolimit,
        logo: logo_NolimitCity
    },
    "Blueprint Gaming": {
        img: img_blueprintgaming,
        logo: logo_BlueprintGaming
    },
    "PlayPearls": {
        img: img_playpears,
        logo: logo_PlayPearls
    },
    "dragoonsoft": {
        img: img_dragoonsoft,
        logo: logo_DragoonSoft
    },
    "Thunderkick": {
        img: img_thunderkick,
        logo: logo_Thunderkick
    },
    "PlayStar": {
        img: img_playstar,
        logo: logo_PlayStar
    },
    "redtiger": {
        img: img_redtiger,
        logo: logo_redtiger
    },
    "GameArt": {
        img: img_gameart,
        logo: logo_GameArt
    },
    "Relax Gaming": {
        img: img_relaxgaming,
        logo: logo_RelaxGaming
    },
    "Wazdan": {
        img: img_wazdan,
        logo: logo_Wazdan,
    },
    "EVOPLAY": {
        img: img_evoplay,
        logo: logo_EVOPLAY
    },
    "playngo": {
        img: img_playngo,
        logo: logo_playngo
    },
    // "1X2 Gaming": {
    //     img: img_1X2Gaming,
    //     logo: logo_1X2Gaming
    // },
    "dreamtech": {
        img: img_dreamtech,
        logo: logo_dreamtech
    },
    // "Elk Studios": {
    //     img: img_ElkStudios,
    //     logo: logo_ElkStudios
    // },
    "MicroGaming Plus Slo": {
        img: img_microgaming,
        logo: logo_microgaming
    },
    "BigTimeGaming": {
        img: img_BigTimeGaming,
        logo: logo_BigTimeGaming
    },
    "greentube": {
        img: img_greentube,
        logo: logo_greentube
    },
    "amatic": {
        img: img_amatic,
        logo: logo_amatic
    },
    "popok": {
        img: img_popok,
        logo: logo_popok
    },
    "kagaming": {
        img: img_kagaming,
        logo: logo_kagaming
    },
    "PlayTechSlot": {
        img: img_PlayTechSlot,
        logo: logo_PlayTechSlot
    },
}
const newJson = []
for (let comp of slot_json) {
    //@ts-ignore
    const vendorImageInfo = compL_slot[comp.vendor as GameCompanyListType]
    if (vendorImageInfo) {
        const vendorObj: SlotImageInterface = {
            id: comp.id,
            name: comp.title,
            vendor: comp.vendor as GameCompanyListType,
            img: vendorImageInfo?.img || "",
            logo: vendorImageInfo?.logo || "",
        }
        newJson.push(vendorObj)
    }
}
export const exportNewSlotJson = newJson